import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryCreator } from '@utils/baseQueryCreator';

import { ENV } from '@constants';

export const bonusServiceApiSlice = createApi({
  endpoints: () => ({}),
  refetchOnReconnect: true,
  reducerPath: 'bonusService',
  baseQuery: (...arguments_) =>
    baseQueryCreator(ENV.VITE_BONUS_SERVICE_API_URL)(...arguments_),
});
